import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDataFetcher } from '../../../hooks';
import { Container } from 'react-bootstrap';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import ErrorList from '../../../errorList';
import { Form, Well, FormHeading } from '../../../form';
import VisitorTypeForm from '../form';
import { IEditVisitorTypePageRouteParams } from './types';
import updateVisitorType from './updateVisitorType';
import deleteVisitorType from './deleteVisitorType';
import schema from './schema';
import {
  ConfirmationModal,
  useModal,
  ConfirmationModalPropsFactory,
} from '../../../modals';

export const EditVisitorTypePage: React.FC = () => {
  const history = useHistory();
  const { showModal, hideModal } = useModal();

  const { id } = useParams<IEditVisitorTypePageRouteParams>();

  const [deleteErrors, setDeleteErrors] = useState<Array<string>>([]);

  const {
    busy,
    errors,
    data: visitorType,
  } = useDataFetcher(`api/visitorTypes/${id}`);

  const handleDelete = () => {
    const confirmationProps =
      ConfirmationModalPropsFactory.CreateDeleteEntityConfirmationModal(
        'Visitor Type',
        +id,
        deleteVisitorType,
        showModal,
        hideModal,
        setDeleteErrors,
        () => history.replace('/admin/visitorTypes'),
      );

    showModal(ConfirmationModal, confirmationProps);
  };

  return (
    <Container fluid>
      <Well>
        <FormHeading
          title="Visitor Type"
          subTitle="Edit"
          backPath="/admin/visitorTypes"
        />
        <AjaxErrorBoundary
          busy={busy}
          loadingText="Loading visitor type"
          errors={errors}
        >
          <ErrorList errors={deleteErrors} />
          <Form
            initialValues={visitorType}
            promise={updateVisitorType}
            validationSchema={schema}
            onSubmit={() => history.push('/admin/visitorTypes')}
          >
            <VisitorTypeForm onDelete={handleDelete} />
          </Form>
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};
